import PersonalityScales from './PersonalityScales';

const PersonalityGraphTexts = {
    'nl-NL': {
        [PersonalityScales.EMOTIONAL_STABILITY]: { text: 'Emotionele stabiliteit', offset: 1100, bottom: false },
        [PersonalityScales.EXTRAVERSION]: { text: 'Extraversie', offset: 210, bottom: true },
        [PersonalityScales.CONSCIENTIOUSNESS]: { text: 'Zorgvuldigheid', offset: 1620, bottom: true },
        [PersonalityScales.OPEN_MINDNESS]: { text: 'Openheid van geest', offset: 470, bottom: false },
        [PersonalityScales.MILDNESS]: { text: 'Vriendelijkheid', offset: 730, bottom: false },
        [PersonalityScales.RELATIONAL_STRESS_TOLERANCE]: [
            {text: 'Relationele', offset: 830},
            {text: 'Stressbestendigheid', offset: 750}
        ],
        [PersonalityScales.DOWN_TO_EARTH]: [{text: 'Nuchterheid', offset: 935}],
        [PersonalityScales.TASK_RELATED_STRESS_TOLERANCE]: [
            {text: 'Taakgerichte', offset: 1040},
            {text: 'Stressbestendigheid', offset: 955}
        ],
        [PersonalityScales.OPTIMISM]: [{text: 'Optimisme', offset: 1150}],
        [PersonalityScales.SOCIABILITY]: [{text: 'Sociabiliteit', offset: 300}],
        [PersonalityScales.DOMINANCE]: [{text: 'Dominantie', offset: 180}],
        [PersonalityScales.ENERGY]: [{ text: 'Energie', offset: 90 }],
        [PersonalityScales.WORKING_SYSTEMATICALLY]: [
            {text: 'Systematisch', offset: 1460},
            {text: 'werken', offset: 1570}
        ],
        [PersonalityScales.RESPONSIBILITY]: [
            {text: 'Verantwoordelijk-', offset: 1240},
            {text: 'heid', offset: 1355}
        ],
        [PersonalityScales.SELF_DISCIPLINE]: [{text: 'Zelfdiscipline', offset: 1360}],
        [PersonalityScales.IMAGINATION]: [{text: 'Verbeelding', offset: 400}],
        [PersonalityScales.INDEPENDENT_THINKING]: [
            {text: 'Onafhankelijk', offset: 500},
            {text: 'Denken', offset: 485}
        ],
        [PersonalityScales.HELPFULNESS]: [{text: 'Behulpzaamheid', offset: 600}],
        [PersonalityScales.TRUST]: [{text: 'Vertrouwen', offset: 720}]
    },
    'en-GB': {
        [PersonalityScales.EMOTIONAL_STABILITY]: { text: 'Emotional stability', offset: 1100, bottom: false },
        [PersonalityScales.EXTRAVERSION]: { text: 'Extraversion', offset: 210, bottom: true },
        [PersonalityScales.CONSCIENTIOUSNESS]: { text: 'Conscientiousness', offset: 1610, bottom: true },
        [PersonalityScales.OPEN_MINDNESS]: { text: 'Open-mindedness', offset: 490, bottom: false },
        [PersonalityScales.MILDNESS]: { text: 'Mildness', offset: 770, bottom: false },
        [PersonalityScales.RELATIONAL_STRESS_TOLERANCE]: [
            {text: 'Relational', offset: 840},
            {text: 'stress tolerance', offset: 770}
        ],
        [PersonalityScales.DOWN_TO_EARTH]: [{text: 'Down to earth', offset: 930}],
        [PersonalityScales.TASK_RELATED_STRESS_TOLERANCE]: [
            {text: 'Task related', offset: 1040},
            {text: 'stress tolerance', offset: 965}
        ],
        [PersonalityScales.OPTIMISM]: [{text: 'Optimism', offset: 1150}],
        [PersonalityScales.SOCIABILITY]: [{text: 'Sociability', offset: 300}],
        [PersonalityScales.DOMINANCE]: [{text: 'Dominance', offset: 180}],
        [PersonalityScales.ENERGY]: [{ text: 'Energy', offset: 90 }],
        [PersonalityScales.WORKING_SYSTEMATICALLY]: [
            {text: 'Working', offset: 1485},
            {text: 'systematically', offset: 1560}
        ],
        [PersonalityScales.RESPONSIBILITY]: [
            {text: 'Responsibility', offset: 1255}
        ],
        [PersonalityScales.SELF_DISCIPLINE]: [{text: 'Self discipline', offset: 1360}],
        [PersonalityScales.IMAGINATION]: [{text: 'Imagination', offset: 400}],
        [PersonalityScales.INDEPENDENT_THINKING]: [
            {text: 'Independent', offset: 500},
            {text: 'thinking', offset: 480}
        ],
        [PersonalityScales.HELPFULNESS]: [{text: 'Helpfulness', offset: 610}],
        [PersonalityScales.TRUST]: [{text: 'Trust', offset: 745}]
    },'de-DE': {
        [PersonalityScales.EMOTIONAL_STABILITY]: { text: 'Emotionale Stabilität', offset: 1100, bottom: false },
        [PersonalityScales.EXTRAVERSION]: { text: 'Extraversion', offset: 210, bottom: true },
        [PersonalityScales.CONSCIENTIOUSNESS]: { text: 'Sorgfältig', offset: 1610, bottom: true },
        [PersonalityScales.OPEN_MINDNESS]: { text: 'Offener Geist', offset: 490, bottom: false },
        [PersonalityScales.MILDNESS]: { text: 'Freundlichkeit', offset: 770, bottom: false },
        [PersonalityScales.RELATIONAL_STRESS_TOLERANCE]: [
            {text: 'Relationale', offset: 840},
            {text: 'Stressbeständigkeit', offset: 770}
        ],
        [PersonalityScales.DOWN_TO_EARTH]: [{text: 'Nüchternheit', offset: 930}],
        [PersonalityScales.TASK_RELATED_STRESS_TOLERANCE]: [
            {text: 'Aufgabenbezogene', offset: 1040},
            {text: 'Stressbeständigkeit', offset: 965}
        ],
        [PersonalityScales.OPTIMISM]: [{text: 'Optimismus', offset: 1150}],
        [PersonalityScales.SOCIABILITY]: [{text: 'Umgänglichkeit', offset: 300}],
        [PersonalityScales.DOMINANCE]: [{text: 'Dominanz', offset: 180}],
        [PersonalityScales.ENERGY]: [{ text: 'Energie', offset: 90 }],
        [PersonalityScales.WORKING_SYSTEMATICALLY]: [
            {text: 'Systematisches', offset: 1485},
            {text: 'Arbeiten', offset: 1560}
        ],
        [PersonalityScales.RESPONSIBILITY]: [
            {text: 'Verantwortlichkeit', offset: 1255}
        ],
        [PersonalityScales.SELF_DISCIPLINE]: [{text: 'Selbstdisziplin', offset: 1360}],
        [PersonalityScales.IMAGINATION]: [{text: 'Fantasie', offset: 400}],
        [PersonalityScales.INDEPENDENT_THINKING]: [
            {text: 'Unabhängiges', offset: 500},
            {text: 'Denken', offset: 480}
        ],
        [PersonalityScales.HELPFULNESS]: [{text: 'Behilflichkeit', offset: 610}],
        [PersonalityScales.TRUST]: [{text: 'Vertrauen', offset: 745}]
    },
    'fr-FR': {
        [PersonalityScales.EMOTIONAL_STABILITY]: { text: 'Stabilité émotionnelle', offset: 1100, bottom: false },
        [PersonalityScales.EXTRAVERSION]: { text: 'Être extraverti', offset: 210, bottom: true },
        [PersonalityScales.CONSCIENTIOUSNESS]: { text: 'Consciencieux(se)', offset: 1610, bottom: true },
        [PersonalityScales.OPEN_MINDNESS]: { text: 'Ouverture d’esprit', offset: 490, bottom: false },
        [PersonalityScales.MILDNESS]: { text: 'Affabilité', offset: 770, bottom: false },
        [PersonalityScales.RELATIONAL_STRESS_TOLERANCE]: [
            {text: 'Résistance au', offset: 840},
            {text: 'stress relationnel', offset: 777}
        ],
        [PersonalityScales.DOWN_TO_EARTH]: [{text: 'Réalisme', offset: 950}],
        [PersonalityScales.TASK_RELATED_STRESS_TOLERANCE]: [
            {text: 'Tolérance au stress', offset: 1020},
            {text: 'liée à la tâche', offset: 968}
        ],
        [PersonalityScales.OPTIMISM]: [{text: 'Optimisme', offset: 1150}],
        [PersonalityScales.SOCIABILITY]: [{text: 'Sociabilité', offset: 300}],
        [PersonalityScales.DOMINANCE]: [{text: 'Dominance', offset: 180}],
        [PersonalityScales.ENERGY]: [{ text: 'Énergie', offset: 90 }],
        [PersonalityScales.WORKING_SYSTEMATICALLY]: [
            {text: 'Travailler', offset: 1480},
            {text: 'de façon systématique', offset: 1540}
        ],
        [PersonalityScales.RESPONSIBILITY]: [
            {text: 'Responsabilité', offset: 1255}
        ],
        [PersonalityScales.SELF_DISCIPLINE]: [{text: 'Autodiscipline', offset: 1360}],
        [PersonalityScales.IMAGINATION]: [{text: 'Imagination', offset: 400}],
        [PersonalityScales.INDEPENDENT_THINKING]: [
            {text: 'Penser de', offset: 500},
            {text: 'façon indépendante', offset: 440}
        ],
        [PersonalityScales.HELPFULNESS]: [{text: 'Serviabilité', offset: 610}],
        [PersonalityScales.TRUST]: [{text: 'Confiance', offset: 745}]
    }
}

export default PersonalityGraphTexts;
